export const accessRightMenu = {
  superAdmin: [ 'events' , 'users' , 'communications' , 'communicationsSent', 'templates', 'setting' ,
    'organizer-settings' , 'event-settings', 'organizer-settings_new' , 'organizer-settings_detail' ,
    'admin-users-settings' , 'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'accounts' , 'canton' , 'canton_new' ,
    'canton_detail' , 'ngxdatatable' , 'profile' ,
    'organization', 'user_new', 'user_detail', 'events_new', 'events_detail', 'blogType',
    'organization_new' , 'organization_detail', 'level-settings', 'target-group', 'frontusers', 'frontUser_new' , 'frontusersnoactive',
    'frontusers_detail', 'confession', 'dynamicData', 'blog_new', 'blog_detail', 'email-builder',
    'tutorial', 'group', 'function', 'default', 'whatsapp', 'budget', 'personnel', 'projectSettings', 'logsHistory',
    'emailEditor', 'news', 'archive', 'running', 'genderType', 'eLearning', 'eLearning_detail', 'platforms', 'platforms_detail',
    'matrix', 'matrixPlatforms', 'modules', 'modules_detail', 'events_all',  'communicationsTemplates',
    'frontVerify', 'frontNoVerify', 'mat-modules', 'matrixModules', 'spaces', 'spaces_new', 'learn-category',
    'learn-category-menu', 'share-links', 'deletedEvents', 'delete-request', 'marketplaces', 'marketplaces_detail',
    'marketplaceCategory', 'marketplaceCategory_new', 'learningPaths', 'learningPaths_detail', 'competency',
    'competency_new', 'deleted',
    'event', 'event_detail'
  ] ,
  countryAdmin: [ 'events' , 'users' , 'communications' , 'communicationsSent', 'templates', 'setting' ,
    'admin-users-settings' , 'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'accounts' , 'canton' ,
    'canton_new' , 'canton_detail' , 'profile' ,
    'organization', 'user_new', 'user_detail', 'events_new', 'events_detail'
    , 'organization_new' , 'organization_detail', 'frontusers', 'frontUser_new', 'frontusers_detail',
    'calendar', 'blog_new', 'blog_detail',
    'tutorial', 'budget', 'personnel', 'news' , 'archive', 'running', 'eLearning', 'eLearning_detail',
    'events_all', 'communicationsTemplates', 'frontVerify', 'deletedEvents', 'deleted',
    'event', 'event_detail'] ,
  subCountryAdmin: [ 'events' , 'users' , 'communications' ,  'communicationsSent', 'templates', 'setting' ,
    'event-cantons', 'admin-users-settings' , 'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'profile' , 'organization'
    , 'organization_new' , 'organization_detail', 'user_new', 'user_detail', 'frontusers', 'frontUser_new',
    'frontusers_detail' , 'events_new',
    'events_detail'
    , 'blog_new', 'blog_detail',   'calendar', 'released-event', 'tutorial', 'whatsapp', 'budget',
    'personnel', 'news', 'archive' ,
    'running', 'eLearning', 'eLearning_detail', 'events_all', 'frontVerify', 'deletedEvents', 'recommend',
  'recommendEvent', 'recommendBlog', 'recommendElearning', 'deleted',
    'event', 'event_detail'] ,
  organisationAdmin: ['events' , 'users' , 'communications' , 'communicationsSent', 'templates',
    'setting' , 'admin-users-settings' ,
    'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'profile', 'user_new',
    'user_detail', 'target-group',
    'frontusers', 'frontUser_new', 'frontusers_detail', 'events_detail' , 'events_new', 'blog_new',
    'organization', 'organization_detail',
    'blog_detail',   'calendar', 'released-event', 'tag', 'tutorial', 'frontusersnoactive', 'budget', 'personnel', 'news',
    'archive', 'running', 'eLearning', 'eLearning_detail', 'events_all', 'communicationsTemplates', 'frontVerify',
    'frontNoVerify', 'org-platform', 'org-modules', 'deletedEvents', 'delete-request',
    'recommendation', 'recommendation-event', 'recommendation-blog', 'recommendation-elearning', 'favorite', 'marketplaces',
    'marketplaces_detail', 'learningPaths', 'learningPaths_detail', 'orgCompetency', 'deleted',
    'event', 'event_detail'
  ] ,
  leader: [ 'events' , 'events_new', 'events_detail' ,  'communications' , 'communicationsSent', 'communicationsTemplates',
    'blog'  , 'manager' , 'documents' , 'pictures' , 'tasks' , 'profile', 'blog_new', 'blog_detail', 'calendar', 'tutorial',
    'news', 'archive' , 'running', 'eLearning', 'eLearning_detail', 'events_all', 'deletedEvents', 'deleted'] ,
  readOnly: [ 'events' , 'events_detail', 'blog'  , 'profile', 'blog_new', 'blog_detail',
    'calendar', 'tutorial', 'news', 'archive',
    'running' , 'eLearning', 'eLearning_detail', 'events_all', 'deletedEvents', 'deleted']
};
